import axios from "axios";
import { toast } from "sonner";

export const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : "/api";

export const L_POSTE = { cuisine: "Cuisine", vente: "Vente", polyvalent: "Polyvalent", conduite: "Conduite" };
export const L_AUTO = { debutant: "Débutant", autonome: "Autonome", responsable: "Peut ouvrir seul" };
export const L_STATUT = {
  etudiant: "Étudiant", auto_entrepreneur: "Auto-entrepreneur",
  interim: "Intérim", cdd_usage: "CDD d'usage", autre: "Autre",
};
export const L_CRIT = {
  ponctualite: "Ponctualité", rapidite: "Rapidité",
  relation_client: "Relation client", proprete: "Propreté",
};
export const JOURS = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];

export const nomComplet = (p) => [p?.prenom, p?.nom].filter(Boolean).join(" ");
export const euros = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} €`;
export const dateFr = (d) => (d && d.length >= 10 ? `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}` : d || "");
export const erreur = (e, defaut) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : defaut;
};

// Telecharge un PDF ou une piece renvoyes par l'API (jeton dans l'en-tete).
export async function telecharger(chemin, nomFichier, params) {
  try {
    const r = await axios.get(`${API}${chemin}`, { params, responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = nomFichier;
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    let msg = "Téléchargement impossible";
    try {
      const txt = await e?.response?.data?.text?.();
      msg = JSON.parse(txt).detail || msg;
    } catch (_) { /* reponse non JSON */ }
    toast.error(msg);
  }
}
